<template>
  <div>
    <!--    기본정보-->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" class="mt-8" />

    <!-- 점검정보  -->

    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 점검정보</h5>
      <div class="writeGridContainer">
        <div>
          <div>점검기관</div>
          <p v-if="isPrint" class="print-input">{{ form.점검기관 }}</p>
          <ml-input v-else v-model="form.점검기관" class="w-full" />
        </div>
        <div>
          <div>점검자</div>
          <p v-if="isPrint" class="print-input">{{ form.점검자 }}</p>
          <ml-input v-else v-model="form.점검자" class="w-full" />
        </div>
        <div>
          <div>점검일</div>
          <p v-if="isPrint" class="print-input">{{ form.점검일 }}</p>
          <date-selector v-else v-model="form.점검일" :readonly="board.readonly" />
        </div>
        <div>
          <div>점검장소</div>
          <p v-if="isPrint" class="print-input">{{ form.점검장소 }}</p>
          <ml-input v-else v-model="form.점검장소" class="w-full" />
        </div>
        <div>
          <div>점검내용</div>
          <p v-if="isPrint" class="print-input">{{ form.점검내용 }}</p>
          <ml-input v-else v-model="form.점검내용" class="w-full" />
        </div>
      </div>
    </div>

    <!--    파일첨부-->
    <file-upload-module id="fileList" class="w-full mt-4" title="파일첨부" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import DateSelector from "@/components/selector/DateSelector";
import FileUploadModule from "@/views/modules/FileUploadModule";

export default {
  components: {
    FileUploadModule,
    DateSelector,
    FieldSelectModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  data() {
    return {
      allCheck: false,
      form: {
        stdInfo: {},
        점검기관: "",
        점검자: "",
        점검일: "",
        점검장소: "",
        점검내용: "",
        fileList: [],
      },
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    addRow() {
      this.form.보호구지급대장.push({ id: Math.random().toString(36).substr(2, 9) });
      this.allCheck = false;
    },
    deleteRow() {
      const selectedRow = this.form.보호구지급대장.filter((row) => row.selected);
      if (selectedRow.length === 0) {
        return;
      }

      this.form.보호구지급대장 = this.form.보호구지급대장.filter((row) => !row.selected);
      this.allCheck = false;
    },
    onClickAllCheckBox() {
      setTimeout(() => {
        if (this.allCheck) {
          this.form.보호구지급대장.forEach((row) => (row.selected = true));
        } else {
          this.form.보호구지급대장.forEach((row) => (row.selected = false));
        }
      }, 100);
    },
  },
  computed: {
    checkedSelectedItem() {
      return this.form.보호구지급대장.filter((row) => row.selected).length === 0;
    },
  },
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  thead {
    th {
      text-align: center;
      font-size: 14px;
      font-weight: 500;
      line-height: 17px;

      background: #f9f9f9;
      border: solid #cdcdcd 1px;
      padding: 6px;
    }
  }
  tbody {
    tr {
      td {
        font-size: 14px;
        font-weight: 500;
        line-height: 17px;
        padding: 5px;
        border: solid #cdcdcd 1px;

        div {
          align-items: center;
        }
      }
    }
  }
}
</style>
